export default "__VITE_ASSET__44l1kbbl__"